<slot name="content">
  <div
    v-if="!custom"
    @dragenter.prevent="handleDragEnter"
    @dragover.prevent="handleDragOver"
    @dragleave="handleDragLeave"
    @drop.prevent="handleDrop"
    :class="{ 'drag-active': activeDrag }"
    class="col-12 drop-area"
    tabindex="0"
  >
    <div class="drop-area-hover">
      <span>{{ $t("componentDragAndDropFile") }}</span>
    </div>
    <input type="file" ref="fileInput" class="hidden" @change="onChange" />
    <div :class="{'mb16' : !width}" class="c-media-header">
      <div v-if="label" class="bold">
        {{ $t(label) }} ( {{ isThumbnail ? (thumbnail ? 1 : 0) :
        Array.isArray(newValue) ? (newValue.length + (files && files.length)) :
        newValue ? 1 : 0 }}/{{ Array.isArray(newValue) ? (newValue.length +
        (files && files.length)) : newValue ? 1 : 0 }} )
      </div>

      <div v-if="size">{{ $t(sizeLabel) }}: {{ size }}</div>
    </div>
    <div v-if="width" class="c-media-header-bottom mt8">
      <div class="mb16">{{ $t(widthLabel) }}: {{ width }}</div>
    </div>

    <div class="c-media">
      <div class="c-list-image">
        <div
          :class="{'image-thumbnail-scroll' : hasScroll, 'image-thumbnail': !hasScroll}"
          class="image-thumbnail-active"
        >
          <div v-if="!imageOnly" class="upload-card">
            <div class="row-icon">
              <img :src="uploadIcon" alt="" />
            </div>
            <div class="col-12 mt5 p0 txt-center">
              <span class="font11">{{ $t("componentDragAndDropFile") }}</span>
            </div>
            <div class="col-12 flex-center">
              <c-button
                v-if="readonly"
                :isLoading="isLoading"
                class="btn btn-browse-disabled"
                value="componentBrowse"
                type="span"
              ></c-button>
              <c-button
                v-else
                @handler="onBrowseFile"
                :isLoading="isLoading"
                class="btn btn-browse"
                value="componentBrowse"
                type="span"
              ></c-button>
            </div>
            <div class="col-12 flex-center mt10">
              <span class="font10">{{ format }}</span>
            </div>
          </div>
          <c-img
            v-if="thumbnail"
            @update:src="thumbnail = ''"
            :src="thumbnail"
            :isDelete="isDelete"
            :readonly="readonly"
            class="detail-img"
            code="key"
            :isThumbnail="isThumbnail"
            :thumbnail="thumbnail"
            file
            :uploaded="uploadPercentage"
            :uploadedIndex="uploadIndexIndex"
            :error="uploadIndex"
          >
            <template v-if="isThumbnail" #img-action="{ row }">
              <span
                class="txt-detail"
                style="color: var(--white); text-decoration: none"
                >{{ $t("productThumbnail") }}</span
              >
            </template>
          </c-img>
          <c-img
            v-if="newValue && newValue.length"
            @update:src="onConfirmDelete"
            :src="newValue"
            :isDelete="isDelete"
            :readonly="readonly"
            class="detail-img"
            code="key"
            :isThumbnail="isThumbnail"
          >
            <template v-if="isThumbnail && !readonly" #img-action="{ row }">
              <span
                @click="onOrderThumbnail(row)"
                class="txt-detail"
                style="color: var(--white)"
                >{{ $t("productThumbnail") }}</span
              >
            </template>
          </c-img>
          <c-img
            v-else-if="readonly && newValue && newValue.length > 0"
            :src="''"
            :isDelete="false"
            :readonly="readonly"
            class="detail-img"
            code="key"
            :isThumbnail="isThumbnail"
          >
          </c-img>
          <c-img
            v-else-if="readonly && !thumbnail"
            :src="''"
            :isDelete="false"
            :readonly="readonly"
            class="detail-img"
            code="key"
            :isThumbnail="isThumbnail"
          >
          </c-img>
          <c-img
            v-if="files && files.length"
            @update:src="removeDraftFile"
            :src="files"
            :isDelete="isDelete"
            :readonly="readonly"
            class="detail-img"
            code="key"
            :isThumbnail="isThumbnail"
            file
            :uploaded="uploadPercentage"
            :uploadedIndex="uploadIndexIndex"
            :error="uploadIndex"
          >
            <template v-if="isThumbnail && !readonly" #img-action="{ row }">
              <span
                @click="onOrderThumbnailFile(row, thumbnail)"
                class="txt-detail"
                style="color: var(--white)"
                >{{ $t("productThumbnail") }}</span
              >
            </template>
          </c-img>
        </div>
      </div>
      <div v-if="invalidFiles && invalidFiles.length" class="col-12">
        <div class="col-12 bold mb5 mt10">
          {{ !uploadError ? $t("componentInvalidFileType") : $t("componentInvalidUpload") }} :
        </div>
        <div
          v-for="item in invalidFiles"
          :key="item"
          class="col-12 invalid-file"
        >
          <span v-html="item?.value" class="txt-detail"></span>
        </div>
      </div>
    </div>
  </div>
</slot>

<div class="c-media">
  <c-modal
    @onClose="onCloseBrowseFile"
    @onConfirm="onUpdateValue"
    labelText="componentSelectMedia"
    :active="isModal"
    modalSize="modal-lg"
    isText
    isOverlay
  >
    <template v-slot:modal="{ row }">
      <div class="row c-modal-select-media">
        <div class="left">
          <div class="row">
            <div v-for="tab in tabFolders" :key="tab" class="col-12">
              <div
                @click="onTabChange(tab?.code)"
                :class="{'active': activeFolder === tab?.code}"
                class="nav-link"
              >
                {{ $t(tab?.value) }}
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div
            v-if="activeFolder === 'C001' && !isDirectory?.code"
            class="row animate-bottom"
          >
            <media-from-computer
              :isArray="isArr"
              @selectedMedia="onSelectMediaOnly"
            ></media-from-computer>
          </div>
          <div
            v-if="activeFolder === 'S001' && !isDirectory?.code"
            class="row animate-bottom p5"
          >
            <div class="wrapper-folder">
              <div
                v-for="folder in folders"
                @click="goDirectory(folder)"
                :key="folder"
                class="card-folder"
              >
                <div class="card-folder-logo">
                  <img
                    :src="require('@/assets/icons/sidebars/folder.svg')"
                    alt=""
                  />
                </div>
                <div class="card-folder-title">
                  <span>{{ folder?.title || "N/A" }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isDirectory?.code" class="row">
            <div class="directory-header">
              <span>
                <img
                  src="@/assets/icons/sidebars/go-left.svg"
                  class="bg-primary w25 h25 radius10 pointer mr10"
                  @click="goBackDirectory"
                />
                <span
                  >{{ isDirectory?.title }}
                  <strong class="txt-secondary bold"
                    >({{ form.code && isArr ? form.code.length :
                    (form.code.length ? [form.code].length : 0) }})</strong
                  ></span
                >
              </span>
            </div>
            <div
              @scroll="handleScroll"
              ref="listMediaBody"
              class="directory-list"
            >
              <!-- <div v-if="isDirectoryLoading" class="row animate-bottom p5 is-loading">
              
            </div> -->
              <div class="row">
                <div v-if="directoriesImage.length" class="row">
                  <div
                    v-for="direct in directoriesImage"
                    class="directory-card"
                  >
                    <input
                      v-model="form.code"
                      :value="direct.key"
                      @change="onChangeSelected"
                      :type="isArr ? 'checkbox' : 'radio'"
                      :multiple="isArr"
                      class="input-checkbox"
                    />
                    <c-img
                      :isOnLoading="isDirectoryLoading"
                      :src="$helper?.getFullImage(direct?.key)"
                      class="detail-img"
                    />
                  </div>
                </div>
                <div
                  v-else-if="!isDirectoryLoading && !directoriesImage.length"
                  class="row animate-bottom p5 is-loading"
                >
                  <c-empty></c-empty>
                </div>
                <div v-if="isDirectoryLoading" class="col-12 mt10">
                  <c-loading :loading="true"></c-loading>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </c-modal>
</div>
